<template>
  <div class="wrapper">
    <div ref="daysPillsWrapper" class="days-pills-wrapper">
      <DayPill
        v-for="(day, index) in daysList" :key="index"
        :index="index"
        :day="day"
        :habitsWithLogs="habitsWithLogs"
        :activityLogs="activityLogs"
        class="days-pills-wrapper__pill"
        :class="{ 'selectDayColor' : index === selectIndex }"
        :style="`&__pill:last-child {margin-right:${isIOS ? '0px' : '20px'};}`"
        :selectDayEvent="selectDayEvent"
      >
        <p style="font-size: 1.4rem; font-weight: 800;">{{ dayFormat(day) }}</p>
        <p style="font-size: 1rem; font-weight: 500;">{{ mounthFormat(day) }}</p>
      </DayPill>
      <div v-if="isIOS" style="min-width: 10px; height: 50px;"></div>
    </div>
  </div>
</template>

<script>
import DayPill from './DayPill.vue';

export default {
  props: {
    selectDay: Function,
    activityLogs: Array,
    habitsWithLogs: Array,
  },
  components: {
    DayPill,
  },
  data() {
    return {
      selectIndex: 0,
      // refactor translations
      mounth: this.$t('months'),
      daysList: this.$getDaysFromNow(30).reverse(),
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollPillsMaxToRight();
      this.selectIndex = this.daysList.length - 1;
    });
  },
  computed: {
    isIOS() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    },
  },
  methods: {
    dayFormat(day) {
      return this.$moment(day).format('DD');
    },
    mounthFormat(day) {
      return this.mounth[this.$moment(day).format('M') - 1];
    },
    selectDayEvent(index) {
      this.selectIndex = index;
      this.selectDay([...this.daysList][index]);
    },
    isSelectedDay(log, day) {
      return this.$moment(log.date).startOf('day').isSame(day, 'day');
    },
    scrollPillsMaxToRight() {
      this.$refs.daysPillsWrapper.scrollTo({ left: this.$refs.daysPillsWrapper.scrollWidth });
    },
  },
};
</script>

<style lang="scss" scoped>
  .wrapper {
    background-image: url('https://thumbs.dreamstime.com/b/cloud-storage-sky-background-digital-ai-data-web-online-technology-social-network-business-concept-system-connection-to-172802493.jpg');
    background-size: cover;
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
  }
  .days-pills-wrapper {
    padding: auto;
    padding-top: 75px;
    padding-bottom: 14px;
    // padding: 75px auto 14px auto!important;
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    overflow-x: auto;
     backdrop-filter: blur(16px) saturate(180%);
    -webkit-backdrop-filter: blur(16px) saturate(180%);
    background-color: #0e1218e0;
    border-bottom-right-radius: 7px;
    border-bottom-left-radius: 7px;

    &__pill {
      position: relative;
      margin: 12px 10px;
      padding: 10px 15px;
      background: $background-light-color;
      border-radius: 18px;
      text-align: center;
      color: $font-brand-color;
      box-shadow:
      0 2.8px 2.2px rgba(0, 0, 0, 0.034),
      0 6.7px 5.3px rgba(0, 0, 0, 0.048),
      0 5px 10px rgba(0, 0, 0, 0.06),
      0 5px 10.9px rgba(0, 0, 0, 0.072),
      0 0px 0px rgba(0, 0, 0, 0.000);
      span {
        font-weight: 700;
        font-size: 28px;
      }
      p {
        font-size: 20px;
      }
      &--day-status {
        // position: absolute;
        // bottom: 0px;
        // right: 19px;
        width: 13px;
        height: 6px;
        background: black;
        border-radius: 30px;
        margin: 1px;
      }
    }
    &__pill:first-child {
      margin-left: 20px;
    }
    &__pill:last-child {
      margin-right: 20px;
    }
    .selectDayColor {
      background: $background-brand-color;
      color: $font-light-color;
    }
  }
  .active {
    background: #8dc898;
  }
  ::v-deep .progress.is-small, .is-small.progress-wrapper.is-not-native {
    height: 0.35rem;
  }
</style>
